import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';

const LEASES_URL = '/api/leases';

export type LeasesRenewalsFilter = {
  page?: number;
  pageSize?: number;
  statuses?: `${MagicDoor.Api.LeaseRenewalStatus}`;
};

export class LeasesRenewalsRepository extends BaseRestRepository {
  public async getRenewalOffers(
    leaseId: string,
    params?: LeasesRenewalsFilter
  ): Promise<MagicDoor.Api.HydratePaginatedLeaseRenewalOffersDto> {
    const url = urlWithQuery(`${LEASES_URL}/${leaseId}/renewals`, params);
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }
  public async createLeaseRenewalOffer(
    leaseId: string,
    model: MagicDoor.Api.CreateLeaseRenewalOfferDto
  ): Promise<MagicDoor.Api.LeaseRenewalOfferDto> {
    const url = `${LEASES_URL}/${leaseId}/renewals`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(model),
    });
    return this.getJsonResponse(response);
  }

  public async getRenewalOffersSummaries(leaseId: string): Promise<MagicDoor.Api.LeaseRenewalOfferSummariesDto> {
    const url = `${LEASES_URL}/${leaseId}/renewals/summaries`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }
  public async sendSigning(leaseId: string, offerId: string): Promise<void> {
    const url = `${LEASES_URL}/${leaseId}/renewals/${offerId}/send-signing`;
    await this.fetchWithAuth(url, {
      method: 'POST',
    });
  }
  public async applyOffer(leaseId: string, offerId: string): Promise<MagicDoor.Api.LeaseRenewalOfferDto> {
    const url = `${LEASES_URL}/${leaseId}/renewals/${offerId}/apply`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
    });
    return this.getJsonResponse(response);
  }
  public async createAndApplyLeaseRenewalOffer(
    leaseId: string,
    model: MagicDoor.Api.CreateLeaseRenewalOfferDto
  ): Promise<MagicDoor.Api.LeaseRenewalOfferDto> {
    const url = `${LEASES_URL}/${leaseId}/renewals/apply`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(model),
    });
    return this.getJsonResponse(response);
  }

  public async deleteOffer(leaseId: string, offerId: string): Promise<void> {
    const url = `${LEASES_URL}/${leaseId}/renewals/${offerId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }

  public async getAutomaticSettings(): Promise<MagicDoor.Api.LeaseRenewalOfferAutomaticSettingGroupsDto> {
    const url = `${LEASES_URL}/renewals/automatic`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async createAutomaticSetting(
    data: MagicDoor.Api.CreateLeaseRenewalOfferAutomaticSettingDto
  ): Promise<MagicDoor.Api.LeaseRenewalOfferAutomaticSettingDto> {
    const url = `${LEASES_URL}/renewals/automatic`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async deleteAutomaticSetting(id: string): Promise<void> {
    const url = `${LEASES_URL}/renewals/automatic/${id}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
